import { styled, theme } from "../../theme";
export const FieldBorder = styled.div `
  border-bottom: thin solid
    ${({ theme, focused }) => focused ? theme.color.primary : theme.color.borderGray};
`;
export const Input = styled.input `
  font-size: 1.375em;
  padding: 0.75em 4px;
  border: none;
  width: 100%;
  min-width: 1px;
  font-family: Gilroy, sans-serif;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.color.gray100};
  background: transparent;
  cursor: default;

  &::placeholder {
    color: ${({ theme }) => theme.color.gray100};
    opacity: 0.75;
  }

  &:focus {
    outline: none;
  }
`;
export const CopyButton = styled.button `
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  gap: 4px;
  align-items: center;
  color: ${({ theme }) => theme.color.primary};
  transition: opacity 0.1s;
  font-size: 0.875em;
  font-weight: 600;
  white-space: nowrap;

  &:hover {
    opacity: 0.7;
  }
`;
export const CopiedIndicator = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.color.primary};
  font-size: ${theme.fontSize[2]}px;
  font-weight: 600;
  margin-left: ${theme.space[2]}px;
`;
export const CopyText = styled.span `
  margin-right: 4px;
`;
